<p-floatlabel>
    <p-autocomplete #vendorAutocomplete
        [(ngModel)]="selectedVendor" 
        [suggestions]="vendors"
        [showClear]="true"
        [forceSelection]="true"
        styleClass="w-100"
        inputStyleClass="form-control"
        [minLength]="MinAutocompleteCharsToSearch"
        (completeMethod)="loadVendors($event)"
        (onSelect)="onChangeSelectedVendor()"
        (onClear)="onChangeSelectedVendor()"
        optionLabel="name"
        [emptyMessage]="l('::NoData')"
        inputId="label">
        <ng-template let-item pTemplate="item">
            <div>{{ item.name }}</div>
        </ng-template>
    </p-autocomplete>
    <label for="vendorAutocomplete">
        <app-label-content [isRequired]="isRequired">
            {{  l('::Vendor') }}
        </app-label-content>
    </label>
</p-floatlabel>